import React, { Fragment } from 'react';
import { Button, Form, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import classNames from 'classnames';

import { TitledCard } from 'Components';
import ReactTable from 'Common/ReactTableWrapper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { InputField, SelectField, TextAreaField } from 'Common/SemanticWrapper';
import { CustomQueryEnum } from 'Common/FieldEnum';
import { makeOptionsData } from 'Common/FormHelper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';

const InputAndDropDownComponent = props => {
  const {
    isAddNewCategory,
    customQueryCategoryListData,
    setSelectedQueryCategory,
    isEditCategory,
    fetchingCustomQueryCategory,
  } = props;
  if (isAddNewCategory || isEditCategory) {
    return (
      <Grid.Column width={4}>
        <Field
          label={null}
          name={CustomQueryEnum.QueryCategoryText}
          component={InputField}
          type={'text'}
          maxLength={30}
          autoFocus
        />
      </Grid.Column>
    );
  } else {
    return (
      <Grid.Column width={4}>
        <Field
          fluid
          component={SelectField}
          loading={fetchingCustomQueryCategory}
          name={CustomQueryEnum.QueryCategory}
          options={makeOptionsData(customQueryCategoryListData)}
          onChange={setSelectedQueryCategory}
        />
      </Grid.Column>
    );
  }
};

const CustomQueryList = props => {
  const {
    reactTableRef,
    columns,
    setSelectedQueryCategory,
    addNewQueryCategory,
    editSelectedQueryCategory,
    removeSelectedQueryCategory,
    saveQueryCategory,
    customQueryCategoryListData,
    loading,
    customQueryData,
    isAddNewCategory,
    showQueryDeleteModel,
    handleDeleteDialog,
    isEditCategory,
    queryCategory,
    fetchingCustomQueryCategory,
    queryCategoryText,
    onResetCategoryClick,
    onRowClickProp,
    onClearClick,
    gridPreferenceSubmitting,
    gridPreferenceLoading,
    showCategoryDeleteModel,
    isStandardQuery,
  } = props;

  const deleteQuestion = showCategoryDeleteModel
    ? 'Are you sure you would like to permanently delete category?'
    : 'Are you sure you would like to permanently delete query?';

  return (
    <Fragment>
      <Form>
        <TitledCard title={'Category'}>
          <Grid className="grid-spacing">
            <Grid.Row>
              <InputAndDropDownComponent
                setSelectedQueryCategory={setSelectedQueryCategory}
                customQueryCategoryListData={customQueryCategoryListData}
                isAddNewCategory={isAddNewCategory}
                isEditCategory={isEditCategory}
                fetchingCustomQueryCategory={fetchingCustomQueryCategory}
              />
              <Grid.Column width={3}>
                <Button
                  fluid
                  content="Add new"
                  onClick={() => {
                    props.change([CustomQueryEnum.QueryCategoryText], '');
                    addNewQueryCategory();
                  }}
                  type={'button'}
                  disabled={isAddNewCategory || isEditCategory}
                />
                <Button
                  style={{
                    marginTop: 10,
                  }}
                  content="Reset"
                  disabled={!isEditCategory && !isAddNewCategory}
                  onClick={onResetCategoryClick}
                  type={'button'}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Button
                  fluid
                  content="Edit selected"
                  disabled={
                    queryCategory === GenericEnum.ZeroString ||
                    isAddNewCategory ||
                    isEditCategory
                  }
                  onClick={editSelectedQueryCategory}
                  type={'button'}
                />
              </Grid.Column>

              <Grid.Column width={3}>
                <Button
                  fluid
                  content="Remove selected"
                  disabled={
                    queryCategory === GenericEnum.ZeroString ||
                    isAddNewCategory ||
                    isEditCategory
                  }
                  onClick={removeSelectedQueryCategory}
                  type={'button'}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <Button
                  fluid
                  content="Save"
                  disabled={!queryCategoryText}
                  onClick={saveQueryCategory}
                  type={'button'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>

        <Grid.Row>
          <Grid.Column width={4}>
            <label className={'text-orange'}>Select a query</label>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column>
            <hr />
          </Grid.Column>
        </Grid.Row>
        <Grid>
          <Grid.Row columns={1} className={'remove-spacing'}>
            <Grid.Column>
              <ReactTable
                reactTableRef={reactTableRef}
                defaultPageSize={20}
                showPageSizeOptions={true}
                minRows={0}
                data={customQueryData}
                noDatatext={'No rows found'}
                resizable={false}
                className="-striped -highlight modalGrid"
                getTrProps={onRowClickProp}
                columns={columns}
                loading={
                  loading ||
                  fetchingCustomQueryCategory ||
                  gridPreferenceLoading ||
                  gridPreferenceSubmitting
                }
                draggableColumns={true}
                showHideColumn={true}
                menu={'hasCogs'}
                saveState={{
                  tableName: TableNamesEnum.CUSTOM_QUERY_LIST_TABLE,
                }}
                gridName={GridEnum.INV_Custom_Query_View}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid className="grid-spacing">
          <Grid.Row>
            <Grid.Column width={5}>
              <Field
                name={CustomQueryEnum.Description}
                component={InputField}
                type="text"
                maxLength={50}
                label={'Description'}
                disabled={isStandardQuery}
              />
            </Grid.Column>
            <Grid.Column style={{ marginTop: 50 }} width={11}>
              <Button
                floated="right"
                content="Clear"
                onClick={onClearClick}
                type={'button'}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid.Row>
          <Grid.Column width={8}>
            <Field
              className={classNames('custom-query-text-area', {
                'disable-text-area': isStandardQuery,
              })}
              name={CustomQueryEnum.Query}
              component={TextAreaField}
              type="text"
              label={'ENTER A QUERY'}
              maxLength={40000}
              readOnly={isStandardQuery}
            />
          </Grid.Column>
        </Grid.Row>
        <YesNoDialog
          showDialog={showQueryDeleteModel || showCategoryDeleteModel}
          title={showQueryDeleteModel ? 'Delete Query' : 'Delete Category'}
          question={deleteQuestion}
          yesCallback={() => {
            handleDeleteDialog(true);
          }}
          noCallback={() => {
            handleDeleteDialog(false);
          }}
        />
      </Form>
    </Fragment>
  );
};
CustomQueryList.propTypes = {
  reactTableRef: PropTypes.object,
  columns: PropTypes.array.isRequired,
  setSelectedQueryCategory: PropTypes.func,
  addNewQueryCategory: PropTypes.func,
  editSelectedQueryCategory: PropTypes.func,
  removeSelectedQueryCategory: PropTypes.func,
  saveQueryCategory: PropTypes.func,
  customQueryCategoryListData: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  customQueryData: PropTypes.array,
  isAddNewCategory: PropTypes.bool,
  showQueryDeleteModel: PropTypes.bool.isRequired,
  handleDeleteDialog: PropTypes.func.isRequired,
  isEditCategory: PropTypes.bool,
  queryCategory: PropTypes.number,
  fetchingCustomQueryCategory: PropTypes.bool.isRequired,
  queryCategoryText: PropTypes.string,
  onResetCategoryClick: PropTypes.func.isRequired,
  onRowClickProp: PropTypes.func.isRequired,
  onClearClick: PropTypes.func,
  savePreference: PropTypes.func,
  gridPreferenceSubmitting: PropTypes.bool.isRequired,
  gridPreferenceLoading: PropTypes.bool.isRequired,
  showCategoryDeleteModel: PropTypes.bool,
  isStandardQuery: PropTypes.bool,
};

export default CustomQueryList;



// WEBPACK FOOTER //
// ./src/pages/utilities/customqueries/components/customQueryList/CustomQueryList.js